<template>
  <a-modal
    title="操作"
    :width="500"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form layout="vertical" :form="form" style="padding-left:40px">
      <a-form-item
        label="用户名 ："
        :labelCol="{lg: {span: 6}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 14}, sm: {span: 10} }"
      ><span>{{ `${user_name}` }}</span>
      </a-form-item>
      <a-form-item
        label="权限管理 ："
        :labelCol="{lg: {span: 6}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 14}, sm: {span: 10} }"
        v-if="visible"
      >
        <a-tree
          checkable
          :defaultExpandedKeys="defaultExpandedKeys"
          :defaultCheckedKeys="defaultCheckedKeys"
          v-model="checkedKeys"
          :treeData="treeData"
        />
      </a-form-item>

    </a-form>
  </a-modal>
</template>

<script>
import { searchForUser, addProjectUser } from '@/api/project'
import { updateRolePermission, getRolePermission } from '@/api/user'
// import { debounce } from '@/utils/util'
import SelectUser from '@/components/selector/SelectUser'
export default {
  name: 'AddRolePermissionModal',
  components: {
    SelectUser
  },
  data () {
    return {
      user_name: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      visible: false,
      id: '',
      mdl: {},
      defaultExpandedKeys: ['user'],
      checkedKeys: [],
      defaultCheckedKeys: [],
      treeData: [
        {
          title: '用户权限',
          key: 'user',
          children: [
            { title: '创建项目', key: '1' },
            { title: '个人信息', key: '2' },
          ]
        },
        {
          title: '管理权限',
          key: 'admin',
          children: [
            { title: '用户管理', key: '3' },
            { title: '项目管理', key: '4' },
            { title: '系统监控', key: '5' },
          ]
        }
      ]
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    edit (user) {
      const _this = this
      //
      debugger
      this.checkedKeys = user.permissions.split(',')
      this.$nextTick(() => {
        _this.user_name = user.name
        _this.visible = true
        _this.id = user.id
      })
    },

    handleOk () {
      //
      const _this = this
      const data = {}
      debugger
      updateRolePermission({
        role_id: this.id,
        permissions: _this.checkedKeys.filter(filterPermission).join(',')
      }).then(res => {
        _this.$message.success('授权用户“' + _this.user_name + '”成功')
        _this.$emit('authorize_ok')
      }).catch(() => {
        _this.$message.error('授权用户“' + _this.user_name + '”失败')
      }).finally(() => {
        _this.visible = false
      })

      function filterPermission (permissions, index, array) {
        if (permissions == 'admin' || permissions == 'user') return false
        return true
      }
    },
    handleCancel () {
      this.visible = false
    }

  }
}
</script>
